export default "__VITE_ASSET__94d56115__"